import React from "react";
import {UserContext} from "./UserContext";
import {FormContextWrapper} from "../core/form_context";
import {Container, InfoTooltip, Loader, MaxBtn} from "../core/components/components";
import {CheckboxInput, TextareaInput} from "../core/input/basic";
import {DateInputUnix} from "../core/input/date";
import {FileUpload} from "../core/input/fileupload";
import {TagsInput} from "../core/input/tags";
import {apiPost} from "../core/api";
import Status from "../core/status";
import UserHistory from "./user_history";

export default class QualificationsMod extends React.Component {
    static contextType = UserContext;
    setState = this.setState.bind(this);
    state = {
        qualification: this.props.qualification || {},
        qualification_file: this.props.qualification?.file || undefined,
    }
    apiPost = apiPost.bind(this);

    submit = e => {
        e.preventDefault()

        this.setState({loading: true})
        this.apiPost("/user/qualifications", this.state.qualification, resp => {
            this.setState({loading: false})
            this.props.reload && this.props.reload()
            if (!this.state.qualification.ID) {
                this.props.close && this.props.close()
            }
        })
    }

    render() {
        if (this.context.user?.role < 80 && !this.context.user?.trainer) {
            return null
        }
        console.log(this.state)
        const {qualification, loading, error, success} = this.state
        return <Container name={`Aus- und Fortbildungen ${qualification.ID ? "bearbeiten" : "hinzufügen"}`}>
            <Status type={"error"} text={error}/>
            <Status type={"success"} text={success}/>
            <FormContextWrapper value={{state: this.state, setState: this.setState}} onSubmit={this.submit}>
                {
                    this.context.user?.role > 80 && <CheckboxInput name={"Anzeigen"} tag={"qualification_showing"}/>
                }
                <TagsInput name={"Detailierter Titel"} entity={"qualDet"} ID={0} tag={"qualification_titleDetail"}/>
                <TagsInput name={"Angezeigter Titel"} entity={"qualDisp"} ID={0} tag={"qualification_titleDisplay"}/>
                <TagsInput name={"Ausbildungsinstitut"} entity={"qualInst"} ID={0} tag={"qualification_institute"}/>
                <TagsInput name={"Ort der Ausbildung"} entity={"qualLoc"} ID={0} tag={"qualification_location"}/>
                <DateInputUnix name={"Start der Ausbildung"} tag={"qualification_startUnix"}/><br/>
                <DateInputUnix name={<>Abschluss <InfoTooltip>Wenn die Ausbildung nicht abgeschlossen wurde, bitte dieses Feld leer lassen bzw. den Inhalt löschen falls er schon eingegeben wurde.</InfoTooltip></>} tag={"qualification_endUnix"}/>
                <FileUpload name={"Zeugnis / Zertifikat"} tag={"qualification_file"} prefix={"qualifications"} setStateParent={this.setState}/>
                <TextareaInput name={"Bemerkung"} tag={"qualification_note"}/>
                <MaxBtn>{qualification.ID ? "Speichern" : "Hinzufügen"}</MaxBtn> <Loader loading={loading}/>

            </FormContextWrapper>

            {qualification.ID && this.context.user?.role>20 && <UserHistory userID={qualification.ID} personType={"qualification"}/>}
        </Container>
    }
}
